import { render, staticRenderFns } from "./FormMixin.vue?vue&type=template&id=50f78a60&scoped=true&"
import script from "./FormMixin.vue?vue&type=script&lang=js&"
export * from "./FormMixin.vue?vue&type=script&lang=js&"
import style0 from "./FormMixin.vue?vue&type=style&index=0&id=50f78a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f78a60",
  null
  
)

export default component.exports